import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import cgi from "../assets/videos/cgi.mp4";
import './Common.css';
import './cgi.css';


const CgiService=()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
        <div className="container pt-5">
            <div className="row cgi-video-container d-flex justify-content-center align-items-center">
                <div className="col-12">
                    <video className="rounded-5 w-100 h-100" data-aos="zoom-in" autoPlay playsInline muted loop style={{objectFit:"cover"}}>
                        <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src={cgi}></source>
                    </video>
                </div>
                
                <div className="row cgi-text-container" data-aos="fade-right">
                    <div className="col-12 text-white">
                        <h1 className="fw-bolder fs-1 ">CGI Videos</h1>
                        <p className="fs-5 lead fw-bold">
                        We specialize in creating stunning CGI (Computer-Generated Imagery) videos that transform concepts into visually captivating stories. 
                        Our CGI videos combine cutting-edge technology with creative expertise to produce high-quality visuals that enhance brand messaging, showcase products, and engage audiences.
                        </p>
                        <p className="fs-5 lead fw-bold">
                        From realistic simulations and detailed 3D renderings to dynamic visual effects, we craft CGI videos that captivate and leave a lasting impact. 
                        Whether it's for marketing campaigns, product demos, or immersive experiences, we bring your ideas to life with precision and creativity through the power of CGI.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CgiService;